import React, { forwardRef } from "react";
import { FormControl } from "@mui/material";
import FieldBridge from "./FieldBridge";
import { StyledInputElement } from "customStyled";

const FormOtpInput = forwardRef((props, ref) => {
  const { id, nextRef, prevRef, onPasteOtp } = props;

  const handlePaste = (e) => {
    if (onPasteOtp) onPasteOtp(e, id);
  };

  const handleKeyDown = (event) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
        event.preventDefault();
        break;
      case "ArrowLeft":
        event.preventDefault();
        if (prevRef?.current) {
          prevRef.current.focus();
        }
        break;
      case "Backspace":
        break;
      case "ArrowRight":
        event.preventDefault();
        if (nextRef?.current) {
          nextRef.current.focus();
        }
        break;
      default:
        if (event.which === 86 || (event.which > 47 && event.which < 58)) {
        } else {
          event.preventDefault();
        }

        break;
    }
  };
  const handleKeyUp = (event) => {
    if (event.key === "Backspace" && !event.target.value && prevRef?.current) {
      prevRef.current.focus();
    }
  };
  return (
    <React.Fragment>
      <FieldBridge
        name={id}
        render={({ handler, hasError, touched, invalid, ...rest }) => {
          const isError = touched && invalid;
          const onChange = (e) => {
            handler().onChange(e); // update form
            if (e.target.value && nextRef?.current) nextRef.current.focus();
          };
          return (
            <FormControl error={isError}>
              <StyledInputElement
                {...handler()}
                inputRef={ref}
                type="text"
                inputProps={{
                  maxLength: 1,
                }}
                onKeyDown={handleKeyDown}
                onChange={onChange}
                onKeyUp={handleKeyUp}
                onPaste={handlePaste}
                id={id}
                name={id}
                autoComplete="off"
                placeholder="0"
                sx={{
                  "& .MuiInputBase-root.MuiOutlinedInput-root": {
                    "& input ": {
                      padding: "10px",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                    },
                  },
                }}
              />
            </FormControl>
          );
        }}
      />
    </React.Fragment>
  );
});

export default FormOtpInput;
